import appConfig from '@nerdwallet/app-config';
import { getLogger } from '@nerdwallet/logging';
import { AnalyticsBrowser } from '@segment/analytics-next';

import { v4 as uuidv4 } from 'uuid';
import { getCookie } from './cookies';

const segmentTrackingLogger = getLogger('SegmentTracking');
const segmentAnalytics = AnalyticsBrowser.load({
  writeKey: appConfig?.SEGMENT?.WRITE_KEY,
});

export type MatchParams = {
  id?: string;
  slug?: string;
};

export type DefaultPagePayload = {
  /* eslint-disable-next-line camelcase */
  traditional_device_id: string;
  /* eslint-disable-next-line camelcase */
  pageview_id: string;
  /* eslint-disable-next-line camelcase */
  deployable_name: string;
  /* eslint-disable-next-line camelcase */
  deployable_version: string;
};

export const trackSegmentPageEvent = (
  pageName: string,
  matchParams: MatchParams
): void => {
  let name = pageName;
  // Add additional info for department and job id page names
  if (pageName === 'careers_department') {
    name += `_${matchParams.slug}`;
  } else if (pageName === 'job') {
    name += `_${parseInt(matchParams.id, 10)}`;
  }

  const defaultPayload: DefaultPagePayload = {
    traditional_device_id: getCookie('cookie_id'),
    pageview_id: uuidv4(),
    // eslint-disable-next-line no-underscore-dangle
    deployable_name: appConfig?._meta?.deployable,
    // eslint-disable-next-line no-underscore-dangle
    deployable_version: appConfig?._meta?.version,
  };

  try {
    segmentAnalytics.page(name, {
      ...defaultPayload,
    });
  } catch (e) {
    segmentTrackingLogger.error(e);
  }
};
